import { usePushNotifications } from '@/hooks/usePushNotifications';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/toast';
import { WorklynxIcon } from '@/components/icons/WorklynxIcon';

export function PushNotificationBanner() {
  const { shouldShowPrompt, isSubscribing, subscribe, dismiss } = usePushNotifications();

  if (!shouldShowPrompt) return null;

  const handleEnable = async () => {
    const success = await subscribe();
    if (success) {
      toast.success('Push notifications enabled.');
    } else {
      toast.error('Unable to enable push notifications. Check your browser settings.');
    }
  };

  return (
    <div className="px-4 pt-4 sm:px-6 lg:px-8 xl:px-10">
      <div className="flex items-center gap-3 rounded-2xl border border-brand-border/40 bg-white px-4 py-3 shadow-sm dark:bg-slate-900">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-soft text-brand">
          <WorklynxIcon name="notifications" size={20} />
        </span>
        <p className="min-w-0 flex-1 text-sm font-medium text-foreground">
          Enable push notifications to stay updated on shift changes and assignments.
        </p>
        <div className="flex items-center gap-2">
          <Button size="sm" onClick={handleEnable} disabled={isSubscribing}>
            {isSubscribing ? 'Enabling...' : 'Enable'}
          </Button>
          <button
            onClick={dismiss}
            className="flex h-8 w-8 items-center justify-center rounded-full text-muted transition-colors hover:bg-slate-100 hover:text-foreground dark:hover:bg-slate-800"
            aria-label="Dismiss notification prompt"
          >
            <WorklynxIcon name="close" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
